var $expandLinks = $('.publications .expand a')

$expandLinks.click(function(e) {
    e.preventDefault();

    var $parentTr = $(this).parents('tr');
    $parentTr.toggleClass('open');
    $parentTr.next('.info').toggleClass('open');
});